/**
 * AR session status values. These are the exact strings `@google/model-viewer`
 * reports through its `ar-status` / `ar-tracking` events, so the WebXR launch
 * sheet can forward them to consumers without translation.
 */
export enum ARStatus {
	NOT_PRESENTING = 'not-presenting',
	SESSION_STARTED = 'session-started',
	OBJECT_PLACED = 'object-placed',
	FAILED = 'failed'
}

export enum ARTracking {
	TRACKING = 'tracking',
	NOT_TRACKING = 'not-tracking'
}
